import React from 'react';
import { ContentListProviders, GetContentInfoParams } from '@smart-tv/typings/content';

import { rootStore } from '../_stores/store-root';
import useVodPlayer from '@smart-tv/components/player/vod-wrapper/_hooks/use-vod-player';
import { usePlayerContext } from '@smart-tv/components/player/_contexts/player-context';

const useSheetStore = (params: GetContentInfoParams) => {
  const vodPlayerContext = useVodPlayer();
  const playerContext = usePlayerContext();

  const isPlayerActive = vodPlayerContext.isPlaying || playerContext.isPlaying;

  // Destructure params to avoid object reference issues in useEffect
  const {
    sid,
    eventId,
    contentId,
    contentType,
    providers,
    providerCollectionId,
    universeId,
    fetchReady,
    subProviderId
  } = params;

  // Memoize the content info params to prevent unnecessary re-renders
  const contentInfoParams = React.useMemo(
    () => ({
      providers: providers ?? ContentListProviders.Subscribed,
      sid,
      eventId,
      contentId,
      contentType,
      providerCollectionId,
      universeId,
      fetchReady,
      subProviderId
    }),
    [
      sid,
      eventId,
      contentId,
      contentType,
      providers,
      providerCollectionId,
      universeId,
      fetchReady,
      subProviderId
    ]
  );

  // Effect for setting the main parameters, runs when the content identifier changes.
  React.useEffect(() => {
    rootStore.sheetStore.setParams(contentInfoParams);
  }, [contentInfoParams]);

  // Effect for updating the player open status, runs whenever it changes.
  React.useEffect(() => {
    rootStore.sheetStore.setIsPlayerOpen(isPlayerActive);
  }, [isPlayerActive]);
};

export default useSheetStore;
